module.exports = __webpack_public_path__ + "img/avoidingOffensesInEnglish_sign.7356121e.png";